import { call, put } from 'redux-saga/effects'
import { KanBoJsonApi } from 'api/Api'
import {
  setDocumentSource
} from '../redux/documentSources'
import fetchDocumentSourceDetails from './fetchDocumentSourceDetails'

export default function * requestRepairDocumentSource (action) {
  const { id } = action.payload

  yield put(setDocumentSource({
    id,
    isBusy: true
  }))

  try {
    yield call(KanBoJsonApi.action, 'RepairDocumentsSource', {
      documentsSourceId: id
    })

    yield fetchDocumentSourceDetails({
      payload: {
        id
      }
    })
  } catch (e) {
    // TODO: Catch only auth error
  } finally {
    yield put(setDocumentSource({
      id,
      isBusy: false
    }))
  }
}
